import { Fragment, useState } from "react";
import { Loader } from "../../../UI/Loaders/Loaders";
import useInvestorsInvestmentWallet from "../../../custom-hooks/useInvestorsInvestmentWallet";
import { useLocation } from "react-router-dom";
import Paginator from "../../Pagination/Pagination.component";
import BackButtonComponent from "../../../NewComponents/BackButton/BackButton.component";
import { formatMoney } from "../../../helpers/formatter";

const InvestorsInvestment = () => {
  const [count, setCount] = useState("");
  const [page, setPage] = useState(1);
  const [size] = useState(20);
  const location = useLocation();
  const { id, savingsWalletId, currency } = location?.state;

  const { data, status, error } = useInvestorsInvestmentWallet({
    FunderId: Number(id),
    page,
    size,
    savingsWalletId: Number(savingsWalletId),
  });
  if (data) {
    if (count === null) {
      setCount(data.totalCount);
    }
  }

  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
        <h3 className="page-title d-flex align-items-center">
          <BackButtonComponent />
        </h3>
      </div>
      {status === "loading" ? (
        <div className="row grid__padding">
          <Loader centered="true" text="Loading Investor Wallet..." />
        </div>
      ) : status !== "loading" && error ? (
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt py-5">
            <i className="fas fa-bell" />
            Unable to fetch Investors wallet Details
          </h4>
        </div>
      ) : status !== "loading" && !error && !data?.data?.length ? (
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt py-5">
            <i className="fas fa-bell" />
            Unable to fetch Investors wallet Details
          </h4>
        </div>
      ) : (
        <div className="row grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>Amount</th>
                  <th>Initiator</th>
                  <th>Transaction Id</th>
                  <th>Transaction Date</th>
                  <th>Transaction Type</th>
                  <th>Transaction Category</th>
                  <th>Transaction Note</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((request, _id) => {
                  const {
                    amount,
                    initiatorUsername,
                    note,
                    runningBalance,
                    transactionDate,
                    transactionId,
                    transactionType,
                    transactioncategory,
                  } = request;
                  return (
                    <tr>
                      <td>{formatMoney(amount, currency)}</td>
                      <td>{initiatorUsername}</td>
                      <td>{transactionId}</td>
                      <td>{transactionDate.substring(0, 10)}</td>
                      <td>{transactionType}</td>
                      <td>{transactioncategory}</td>
                      <td>{note}</td>
                      <td>{formatMoney(runningBalance, currency)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Paginator
            size={size}
            page={page}
            count={count}
            changeCurrentPage={(page) => setPage(page)}
          />
        </div>
      )}
    </Fragment>
  );
};

export default InvestorsInvestment;
